__turbopack_context__.v({
  "content": "MarketingBanner-module__3tJKsG__content",
  "ctaIcon": "MarketingBanner-module__3tJKsG__ctaIcon",
  "ctaText": "MarketingBanner-module__3tJKsG__ctaText",
  "emeraldBanner": "MarketingBanner-module__3tJKsG__emeraldBanner",
  "hide": "MarketingBanner-module__3tJKsG__hide",
  "m2LiveBanner": "MarketingBanner-module__3tJKsG__m2LiveBanner",
  "oneMore": "MarketingBanner-module__3tJKsG__oneMore",
  "onlyDesktop": "MarketingBanner-module__3tJKsG__onlyDesktop",
  "onlyMobile": "MarketingBanner-module__3tJKsG__onlyMobile",
  "performanceLabBanner": "MarketingBanner-module__3tJKsG__performanceLabBanner",
  "performanceLabBannerV2": "MarketingBanner-module__3tJKsG__performanceLabBannerV2",
  "pulsomicsBanner": "MarketingBanner-module__3tJKsG__pulsomicsBanner",
  "rotatingBanner": "MarketingBanner-module__3tJKsG__rotatingBanner",
  "sddTwoHourBanner": "MarketingBanner-module__3tJKsG__sddTwoHourBanner",
  "shippingBanner": "MarketingBanner-module__3tJKsG__shippingBanner",
  "tile": "MarketingBanner-module__3tJKsG__tile",
  "track": "MarketingBanner-module__3tJKsG__track",
  "viewport": "MarketingBanner-module__3tJKsG__viewport",
});
